import { render } from "./TableView.vue?vue&type=template&id=4741d2de"
const script = {}

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__